var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['p2p-net', _vm.platform, { lg: _vm.large }],attrs:{"title":_vm.label,"role":"img","aria-label":_vm.label}},[_vm._v(_vm._s(_vm.letter))])}
var staticRenderFns = []

export { render, staticRenderFns }